
import { useStore } from "vuex"
import { ref } from 'vue'
import ActionResponseBox from "components/ActionResponseBox/ActionResponseBox"

export default {
    name: "CTABox",
    components: {
        ActionResponseBox
    },
    props: {
        result: {
            type: Object,
            required: true
        },
        ctaId: {
            type: String,
            required: false
        }
    },
    setup(props){
        const store = useStore()

        const displayCopyResponse = ref(false)

        const actionResponseLifeTime = 2500;
        const actionResponseFadeOutTime = 500;

        const handleCopyLink = function (link) {
    
            // Copy link to clipboard
            navigator.clipboard.writeText(link);

            // Show the copied text in ActionResponseBox
            displayCopyResponse.value = true

            //decide when to hide ActionResponse
            setTimeout(() => { 
                displayCopyResponse.value = false
            }, actionResponseLifeTime)

        }

        return {
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: `CTABox-${props.ctaId}`,
                    labelKey
                }),
            handleCopyLink,
            displayCopyResponse,
            actionResponseLifeTime,
            actionResponseFadeOutTime
        }
    }
}